import {ReactTableDefaults} from 'react-table'
import moment from 'moment'
import Api from './services/Api'
import {userLogout} from './actions/AuthActions'

require('moment/locale/pt-br');

export default async store => {

  moment.locale('pt-br')

  Object.assign(ReactTableDefaults, {
    previousText: 'Anterior',
    nextText: 'Próximo',
    loadingText: 'Carregando',
    noDataText: 'Nenhum dado encontrado',
    pageText: 'Página',
    ofText: 'de',
    rowsText: 'linhas',
    //defaultPageSize: 20,
  });

  Api.setErrorHandler(err => {
    if (err.status === 401 || err.status === 403) {
      store.dispatch(userLogout());
      alert('Acesso não autorizado');
    }
  });

  await Api.setup(store);
};



// WEBPACK FOOTER //
// ./src/setup.js